module.exports = __webpack_public_path__ + "img/daily-feeding-1.8ba8e128.jpg";